import { useIntl } from 'react-intl';

import { useEmotionDetectorContext } from '../../EmotionDetectorContextProvider';
import { messages } from '../../messages';
import { NavButton } from '../styles';

interface NavigationButtonProps {
	currentPage: 'home' | 'camera' | 'log';
}

const NAV_CONFIG = {
	camera: {
		targetScreen: 'log' as const,
		messageKey: 'logButton' as const,
	},
	log: {
		targetScreen: 'camera' as const,
		messageKey: 'cameraButton' as const,
	},
} as const;

export default function NavigationButton({ currentPage }: NavigationButtonProps) {
	const { formatMessage } = useIntl();
	const { setActiveScreen } = useEmotionDetectorContext();

	// No navigation button on home page
	if (currentPage === 'home') return null;

	const config = NAV_CONFIG[currentPage];

	return (
		<NavButton onPress={() => setActiveScreen(config.targetScreen)}>
			{formatMessage(messages[config.messageKey])}
		</NavButton>
	);
}
